import React from 'react';
import ReactDOM from 'react-dom';
import './Form.css';
import './index.css';
import Teacher from './Componets/Teacher'; 
import Pro_Teacher from './Componets/Pro_Teacher';
import Student from './Componets/Student';
import Pro_Student from './Componets/Pro_Student';
import Header from './Componets/Header';
import Footer from './Componets/Footer';

class MyForm extends React.Component {
  constructor() {
    super();
    this.state = {
      login: '',
      pass: '',
      human_id: '',
      human_type: ''
    };
  }
  ChangeLogin(e) {
    this.setState({ login: e.target.value })
  }
  ChangePass(e) {
    this.setState({ pass: e.target.value })
  }




  SendAuth() {
    fetch(`/loginForm?login=${this.state.login}&pass=${this.state.pass}`)
      .then(res => res.json())
      .then(json => {
        if (json.length > 0) {
          this.setState({ human_id: json[0].id_teacher, human_type: json[0].status_type })
        } else {
          this.setState({ human_id: 0, human_type: 0 })
          document.getElementById("ErrorLogin").innerHTML = "Такой учетной записи не существует!!!"
        }
      }
      )
  }
   
  render() {
    if (this.state.human_type == 1) {
      return (
              <div>
              <Pro_Teacher id_teacher={this.state.human_id} h_type={this.state.human_type}  />
              <Teacher id_teacher={this.state.human_id} h_type={this.state.human_type} />
              </div>
              )
              } else if (this.state.human_type == 2) {
              return (
              <div>
              <Pro_Student  id_student={this.state.human_id} />
              <Student id_student={this.state.human_id}/>
              </div>
        
      )
    } else {
      return (
        <div>
          <Header />
        <div className="login-page">
        <div className="form__autentification">
          <p className="form__header">Расписание</p>
         <div className="div__login"> 
         <label className="labal__login" htmlFor="username">Логин</label>
          <input className="input__login" type="text" onChange={this.ChangeLogin.bind(this)} data-validate />
          </div> 
          <div className="div__pass">
          <label className="label__pass" htmlFor="password">Пароль</label>
          <input className="input__pass" type="password" onChange={this.ChangePass.bind(this)} />
          </div>
          
          <input className="login__submit" type="submit" value="Вход" onClick={this.SendAuth.bind(this)} data-validate />
          <div id='ErrorLogin'></div>
        </div>
        </div>
        </div>
      );
    }
  }
}
ReactDOM.render(
  <div>
    <MyForm />
    <Footer />
  </div>
,
  document.getElementById('root')
);

